export const radius = 30.0;
export const tickWidth = 10.0;



// WEBPACK FOOTER //
// ./src/constants.js